(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/drawselector/assets/javascripts/collections/drawselector.js') >= 0) return;  svs.modules.push('/components/sport/drawselector/assets/javascripts/collections/drawselector.js'); 'use strict';

var Draw = svs.sport.drawselector.models.Draw;
var DrawselectorList = Backbone.Collection.extend({
  initialize: function initialize() {},
  setData: function setData(draws, currentDraw) {
    var _this = this;

    draws.forEach(function (draw) {
      var newDraw = new Draw();
      newDraw.setData(draw, currentDraw);

      _this.add(newDraw);
    });
  },
  getCurrentDraw: function getCurrentDraw() {
    return this.models.filter(function (model) {
      return model.get('isCurrentDraw');
    })[0];
  }
});
setGlobal('svs.sport.drawselector.collections.DrawselectorList', DrawselectorList);
 })(window);